import defaultDeLinks from '~/portals/default__de/links.json'
import defaultEnLinks from '~/portals/default__en/links.json'

import portalTravantoDeDeLinks from '~/portals/portal.travanto.de__de/links.json'
// Production "Lizenznehmer" portals:
import harzTravelDeDeLinks from '~/portals/www.harz-travel.de__de/links.json'
import sauerlandTravelDeDeLinks from '~/portals/www.sauerland-travel.de__de/links.json'
// Production "Travanto" portals:
import allgaeuTravelComDeLinks from '~/portals/www.allgaeu-travel.com__de/links.json'
import amrumTravelDeDeLinks from '~/portals/www.amrum-travel.de__de/links.json'
import bauernhofLodgeDeDeLinks from '~/portals/www.bauernhof-lodge.de__de/links.json'
import boltenhagenTravelDeDeLinks from '~/portals/www.boltenhagen-travel.de__de/links.json'
import buesumTravelComDeLinks from '~/portals/www.buesum-travel.com__de/links.json'
import chiemseeTravelDeDeLinks from '~/portals/www.chiemsee-travel.de__de/links.json'
import cuxhavenLodgeDeDeLinks from '~/portals/www.cuxhaven-lodge.de__de/links.json'
import darssTravelDeDeLinks from '~/portals/www.darss-travel.de__de/links.json'
import fehmarnTravelDeDeLinks from '~/portals/www.fehmarn-travel.de__de/links.json'
import foehrTravelDeDeLinks from '~/portals/www.foehr-travel.de__de/links.json'
import hamburgLodgeDeDeLinks from '~/portals/www.hamburg-lodge.de__de/links.json'
import hamburgLodgeDeEnLinks from '~/portals/www.hamburg-lodge.de__en/links.json'
import hundeLodgeDeDeLinks from '~/portals/www.hunde-lodge.de__de/links.json'
import kielTravelDeDeLinks from '~/portals/www.kiel-travel.de__de/links.json'
import luebeckTravelDeDeLinks from '~/portals/www.luebeck-travel.de__de/links.json'
import lueneburgTravelDeDeLinks from '~/portals/www.lueneburg-travel.de__de/links.json'
import masurenTravelComDeLinks from '~/portals/www.masuren-travel.com__de/links.json'
import masurenTravelComEnLinks from '~/portals/www.masuren-travel.com__en/links.json'
import mueritzTravelDeDeLinks from '~/portals/www.mueritz-travel.de__de/links.json'
import polenTravelComDeLinks from '~/portals/www.polen-travel.com__de/links.json'
import prahaLodgeComDeLinks from '~/portals/www.praha-lodge.com__de/links.json'
import ruegenTravelDeDeLinks from '~/portals/www.ruegen-travel.de__de/links.json'
import scharbeutzTravelDeDeLinks from '~/portals/www.scharbeutz-travel.de__de/links.json'
import schwarzwaldTravelDeDeLinks from '~/portals/www.schwarzwald-travel.de__de/links.json'
import seeFerienwohnungDeDeLinks from '~/portals/www.see-ferienwohnung.de__de/links.json'
import sizilienTravelComDeLinks from '~/portals/www.sizilien-travel.com__de/links.json'
import sizilienTravelComEnLinks from '~/portals/www.sizilien-travel.com__en/links.json'
import stpeterordingTravelDeDeLinks from '~/portals/www.stpeterording-travel.de__de/links.json'
import syltTravelDeDeLinks from '~/portals/www.sylt-travel.de__de/links.json'
import syltTravelDeEnLinks from '~/portals/www.sylt-travel.de__en/links.json'
import timmendorferstrandTravelDeDeLinks from '~/portals/www.timmendorferstrand-travel.de__de/links.json'
import travantoDeDeLinks from '~/portals/www.travanto.de__de/links.json'
import travantoDeEnLinks from '~/portals/www.travanto.de__en/links.json'
import usedomTravelNetDeLinks from '~/portals/www.usedom-travel.net__de/links.json'
import wintersportLodgeDeDeLinks from '~/portals/www.wintersport-lodge.de__de/links.json'

import defaultDeTrustpilot from '~/portals/default__de/trustpilot.json'
import defaultEnTrustpilot from '~/portals/default__en/trustpilot.json'
import travantoDeDeTrustpilot from '~/portals/www.travanto.de__de/trustpilot.json'

import cuxhavenLodgeDeDeLocations from '~/portals/www.cuxhaven-lodge.de__de/locations.json'
import stpeterordingTravelDeDeLocations from '~/portals/www.stpeterording-travel.de__de/locations.json'

import defaultDeMain from '~/portals/default__de/main.json'
import defaultEnMain from '~/portals/default__en/main.json'
import harzTravelDeDeMain from '~/portals/www.harz-travel.de__de/main.json'
import sauerlandTravelDeDeMain from '~/portals/www.sauerland-travel.de__de/main.json'
import fehmarnTravelDeDeMain from '~/portals/www.fehmarn-travel.de__de/main.json'

const usePortalData = () => {
  // const portalData = useState(() => shallowRef(null))
  //
  // if (portalData.value !== null) {
  //   return {
  //     links: portalData.value.links
  //   }
  // }

  const { currentPortal } = usePortals()
  const currentPortalString = currentPortal.value?.portal?.portal ?? ''
  const currentLangString = currentPortal.value?.portal?.lang ?? ''

  const errorData = {
    links: {
      portal_domain_name: '',
      portal_name: '',
      location: null,
      preposition: '',
      preposition2: '',
      logo: '/svg/logo/logo_travanto.svg',
      regiondiscovers: [],
      regionbookings: [],
      vacation_links: [],
      gastgeber_url: '',
      ferienwohnung_vermieten_url: '',
      footer: {
        link_list: [],
        social_networks: [],
        agb: {
          url: ''
        },
        datenschutz: {
          url: ''
        }
      }
    },
    trustpilot: {
      url: '',
      img_small: '',
      img: '',
      widget: '',
      alt: ''
    },
    locations: null,
    main: null
  }

  const defaultData = {
    de: {
      links: defaultDeLinks,
      trustpilot: defaultDeTrustpilot,
      locations: null,
      main: defaultDeMain
    },
    en: {
      links: defaultEnLinks,
      trustpilot: defaultEnTrustpilot,
      locations: null,
      main: defaultEnMain
    }
  }

  const dataForAllPortals = {
    'http://portal.travanto.de': {
      de: {
        links: portalTravantoDeDeLinks,
        trustpilot: null,
        locations: null,
        main: null
      }
    },
    'http://www.harz-travel.de': {
      de: {
        links: harzTravelDeDeLinks,
        trustpilot: null,
        locations: null,
        main: harzTravelDeDeMain
      }
    },
    'http://www.sauerland-travel.de': {
      de: {
        links: sauerlandTravelDeDeLinks,
        trustpilot: null,
        locations: null,
        main: sauerlandTravelDeDeMain
      }
    },
    'http://www.allgaeu-travel.com': {
      de: {
        links: allgaeuTravelComDeLinks,
        trustpilot: null,
        locations: null,
        main: null
      }
    },
    'http://www.amrum-travel.de': {
      de: {
        links: amrumTravelDeDeLinks,
        trustpilot: null,
        locations: null,
        main: null
      }
    },
    'http://www.bauernhof-lodge.de': {
      de: {
        links: bauernhofLodgeDeDeLinks,
        trustpilot: null,
        locations: null,
        main: null
      }
    },
    'http://www.boltenhagen-travel.de': {
      de: {
        links: boltenhagenTravelDeDeLinks,
        trustpilot: null,
        locations: null,
        main: null
      }
    },
    'http://www.buesum-travel.com': {
      de: {
        links: buesumTravelComDeLinks,
        trustpilot: null,
        locations: null,
        main: null
      }
    },
    'http://www.chiemsee-travel.de': {
      de: {
        links: chiemseeTravelDeDeLinks,
        trustpilot: null,
        locations: null,
        main: null
      }
    },
    'http://www.cuxhaven-lodge.de': {
      de: {
        links: cuxhavenLodgeDeDeLinks,
        trustpilot: null,
        locations: cuxhavenLodgeDeDeLocations,
        main: null
      }
    },
    'http://www.darss-travel.de': {
      de: {
        links: darssTravelDeDeLinks,
        trustpilot: null,
        locations: null,
        main: null
      }
    },
    'http://www.fehmarn-travel.de': {
      de: {
        links: fehmarnTravelDeDeLinks,
        trustpilot: null,
        locations: null,
        main: fehmarnTravelDeDeMain
      }
    },
    'http://www.foehr-travel.de': {
      de: {
        links: foehrTravelDeDeLinks,
        trustpilot: null,
        locations: null,
        main: null
      }
    },
    'http://www.hamburg-lodge.de': {
      de: {
        links: hamburgLodgeDeDeLinks,
        trustpilot: null,
        locations: null,
        main: null
      },
      en: {
        links: hamburgLodgeDeEnLinks,
        trustpilot: null,
        locations: null,
        main: null
      }
    },
    'http://www.hunde-lodge.de': {
      de: {
        links: hundeLodgeDeDeLinks,
        trustpilot: null,
        locations: null,
        main: null
      }
    },
    'http://www.kiel-travel.de': {
      de: {
        links: kielTravelDeDeLinks,
        trustpilot: null,
        locations: null,
        main: null
      }
    },
    'http://www.luebeck-travel.de': {
      de: {
        links: luebeckTravelDeDeLinks,
        trustpilot: null,
        locations: null,
        main: null
      }
    },
    'http://www.lueneburg-travel.de': {
      de: {
        links: lueneburgTravelDeDeLinks,
        trustpilot: null,
        locations: null,
        main: null
      }
    },
    'http://www.masuren-travel.com': {
      de: {
        links: masurenTravelComDeLinks,
        trustpilot: null,
        locations: null,
        main: null
      },
      en: {
        links: masurenTravelComEnLinks,
        trustpilot: null,
        locations: null,
        main: null
      }
    },
    'http://www.mueritz-travel.de': {
      de: {
        links: mueritzTravelDeDeLinks,
        trustpilot: null,
        locations: null,
        main: null
      }
    },
    'http://www.polen-travel.com': {
      de: {
        links: polenTravelComDeLinks,
        trustpilot: null,
        locations: null,
        main: null
      }
    },
    'http://www.praha-lodge.com': {
      de: {
        links: prahaLodgeComDeLinks,
        trustpilot: null,
        locations: null,
        main: null
      }
    },
    'http://www.ruegen-travel.de': {
      de: {
        links: ruegenTravelDeDeLinks,
        trustpilot: null,
        locations: null,
        main: null
      }
    },
    'http://www.scharbeutz-travel.de': {
      de: {
        links: scharbeutzTravelDeDeLinks,
        trustpilot: null,
        locations: null,
        main: null
      }
    },
    'http://www.schwarzwald-travel.de': {
      de: {
        links: schwarzwaldTravelDeDeLinks,
        trustpilot: null,
        locations: null,
        main: null
      }
    },
    'http://www.see-ferienwohnung.de': {
      de: {
        links: seeFerienwohnungDeDeLinks,
        trustpilot: null,
        locations: null,
        main: null
      }
    },
    'http://www.sizilien-travel.com': {
      de: {
        links: sizilienTravelComDeLinks,
        trustpilot: null,
        locations: null,
        main: null
      },
      en: {
        links: sizilienTravelComEnLinks,
        trustpilot: null,
        locations: null,
        main: null
      }
    },
    'http://www.stpeterording-travel.de': {
      de: {
        links: stpeterordingTravelDeDeLinks,
        trustpilot: null,
        locations: stpeterordingTravelDeDeLocations,
        main: null
      }
    },
    'http://www.sylt-travel.de': {
      de: {
        links: syltTravelDeDeLinks,
        trustpilot: null,
        locations: null,
        main: null
      },
      en: {
        links: syltTravelDeEnLinks,
        trustpilot: null,
        locations: null,
        main: null
      }
    },
    'http://www.timmendorferstrand-travel.de': {
      de: {
        links: timmendorferstrandTravelDeDeLinks,
        trustpilot: null,
        locations: null,
        main: null
      }
    },
    'http://www.travanto.de': {
      de: {
        links: travantoDeDeLinks,
        trustpilot: travantoDeDeTrustpilot,
        locations: null,
        main: null
      },
      en: {
        links: travantoDeEnLinks,
        trustpilot: null,
        locations: null,
        main: null
      }
    },
    'http://www.usedom-travel.net': {
      de: {
        links: usedomTravelNetDeLinks,
        trustpilot: null,
        locations: null,
        main: null
      }
    },
    'http://www.wintersport-lodge.de': {
      de: {
        links: wintersportLodgeDeDeLinks,
        trustpilot: null,
        locations: null,
        main: null
      }
    }
  }

  if (
    !Object.prototype.hasOwnProperty.call(dataForAllPortals, currentPortalString) ||
    !Object.prototype.hasOwnProperty.call(dataForAllPortals[currentPortalString], currentLangString)
  ) {
    // eslint-disable-next-line no-console
    console.error(`Error: undefined portal or no data available for the portal+language: ${currentPortalString}, ${currentLangString}`)
    return {
      links: errorData.links,
      trustpilot: errorData.trustpilot,
      locations: errorData.locations,
      main: errorData.main
    }
  }

  function mergeWithDefaultDataFile (portalDataFile, defaultDataFile) {
    if (portalDataFile === null) {
      return
    }
    for (const key in defaultDataFile) {
      if (!Object.prototype.hasOwnProperty.call(defaultDataFile, key) || defaultDataFile[key] === undefined) {
        continue
      }
      if (!Object.prototype.hasOwnProperty.call(portalDataFile, key) || portalDataFile[key] === undefined) {
        portalDataFile[key] = defaultDataFile[key]
      }
    }
  }

  // portalData.value = dataForAllPortals[currentPortalString][currentLangString]

  const defaultLinks = defaultData[currentLangString].links
  const portalLinks = dataForAllPortals[currentPortalString][currentLangString].links
  const defaultTrustpilot = defaultData[currentLangString].trustpilot
  const portalTrustpilot = dataForAllPortals[currentPortalString][currentLangString].trustpilot
  const defaultLocations = defaultData[currentLangString].locations
  const portalLocations = dataForAllPortals[currentPortalString][currentLangString].locations
  const defaultMain = defaultData[currentLangString].main
  const portalMain = dataForAllPortals[currentPortalString][currentLangString].main

  mergeWithDefaultDataFile(portalLinks, defaultLinks)
  mergeWithDefaultDataFile(portalTrustpilot, defaultTrustpilot)
  mergeWithDefaultDataFile(portalLocations, defaultLocations)
  mergeWithDefaultDataFile(portalMain, defaultMain)

  return {
    links: portalLinks,
    trustpilot: portalTrustpilot,
    locations: portalLocations,
    main: portalMain ?? defaultMain,
    portalsWithLongLogos: ['timmendorferstrand-travel.de', 'stpeterording-travel.de']
  }
}

export default usePortalData
